// nico_frontend/src/app/hooks/useGetRoleByRoute.js

import { useLocation } from 'react-router-dom';

const useGetRoleByRoute = () => {
  const location = useLocation();

  const getTypeFromUrl = () => {
    const types = ['broker', 'partner', 'insured'];
    const foundType = types.find(type => location.pathname.includes(type));
    return foundType || 'broker';
  };

  const getTranslateType = typeItem => {
    switch (typeItem) {
      case 'broker':
        return 'corredor';
      case 'partner':
        return 'partner';
      case 'insured':
        return 'asegurado';
      default:
        return '';
    }
  };

  const type = getTypeFromUrl();
  const translateType = getTranslateType(type);

  return { type, translateType };
};

export default useGetRoleByRoute;
